import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { normalizeHref } from 'wix-rich-content-common';
import { alignmentClassName, sizeClassName } from './classNameStrategies.js';
import ButtonViewer from './components/button-viewer.js';
import 'classnames';
import 'lodash';
import './style-inject.es-746bb8ed.js';
import './default-styles-74c82233.js';
import './types.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ButtonComponent extends Component {
  render() {
    var _a, _b, _c, _d;
    const {
      componentData: { button },
      settings: { onClick, themeData },
      config,
      helpers,
      anchorTarget,
      theme
    } = this.props;
    const { colors: { actionColor, bgColor } = {} } = themeData || (config == null ? void 0 : config.themeData) || {};
    const buttonText = button.settings.buttonText;
    const url = (_a = button.settings) == null ? void 0 : _a.url;
    let linkButtonSettings = {};
    if (url) {
      linkButtonSettings = {
        url: normalizeHref(url),
        target: button.settings.target,
        rel: button.settings.rel
      };
    }
    const style = __spreadValues(__spreadValues({
      border: "0px solid blue",
      color: ((_b = this.props.settings.colors) == null ? void 0 : _b.color1) || bgColor,
      background: ((_c = this.props.settings.colors) == null ? void 0 : _c.color8) || actionColor,
      borderColor: ((_d = this.props.settings.colors) == null ? void 0 : _d.color8) || actionColor
    }, this.props.style), button.design);
    return /* @__PURE__ */ React.createElement(
      ButtonViewer,
      __spreadValues({
        style,
        buttonText,
        theme,
        onClick,
        helpers,
        anchorTarget
      }, linkButtonSettings)
    );
  }
}
__publicField(ButtonComponent, "alignmentClassName", (componentData, theme, styles, isMobile) => alignmentClassName(componentData, theme, styles));
__publicField(ButtonComponent, "sizeClassName", (componentData, theme, styles, isMobile) => sizeClassName(componentData, theme));
ButtonComponent.propTypes = {
  componentData: PropTypes.object,
  style: PropTypes.object,
  anchorTarget: PropTypes.string,
  settings: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  helpers: PropTypes.object,
  config: PropTypes.object
};

export { ButtonComponent as default };
//# sourceMappingURL=button-component.js.map
